<template>
  <div class="footer" @click="handleClick('点击了我')">
    <div class="footer-left">
      <div class="title">{{title ? title : footerContent.title ? footerContent.title : '合计金额'}}</div>
      <div class="money">
        <span class="iconfont money-icon">{{'\ue60a'}}</span>
        <span>{{Number(footerContent.money ? Number(footerContent.money).toFixed(2) : '0.00')}}</span>
      </div>
    </div>
    <div class="footer-right">
      <div :class="['look-button',proxyFlag ? 'disable' : '']">
        {{footerContent.buttonTitle ? footerContent.buttonTitle : '预览'}}
      </div>
    </div>
  </div>
</template>
<script>
import {
  NumFormat
} from '@utils/basicUtil'
export default {
  props: {
    footerContent: {
      type: Object,
      default: () => {}
    },
    proxyFlag: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
    }
  },
  computed: {
    autoNumber () {
      return function (num) {
        return NumFormat(num)
      }
    }
  },
  methods: {
    handleClick () {
      if (this.proxyFlag) {
      } else {
        this.$emit('look')
      }
    }
  }
}
</script>
<style lang="less" scoped>
  .footer{
    box-sizing: border-box;
    padding: 24px 24px 0px;
    box-shadow: 0px 0px 10px 2px rgb(230, 227, 227);
    height: 168px;
    background: #FFFFFF;
    position: fixed;
    width: 100%;
    bottom: 0;
    display: flex;
    justify-content: space-between;
    .footer-left{
      flex-grow: 1;
      margin-right: 16px;
    }
    .footer-right {
      width: 500px;
    }
    .title{
      font-size: 24px;
      color: #9EA9B9;
    }
    .money{
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      color: #3E4966;
      font-family: 'Bahnschrift','pingfang';
      font-size: 40px;
      font-weight: bold;
      span:nth-of-type(2){
        display: inline-block;
      }
      .money-icon{
        font-size: 18px;
        vertical-align: middle;
        display: inline-block;
        width: 30px;
        // margin-top: -28px;
      }
    }
    .look-button{
      width: 100%;
      height: 80px;
      background: #3378FF;
      color: #FFFFFF;
      border-radius: 4px;
      text-align: center;
      line-height: 80px;
      font-size: 28px;
      font-weight: bold;
    }
    .disable {
      width: 480px;
      height: 80px;
      background: #3378FF;
      opacity: 0.64;
      color: #FFFFFF;
      border-radius: 4px;
      text-align: center;
      line-height: 80px;
      font-size: 28px;
      font-weight: bold;
    }
  }
</style>>
